import Image from 'next/image';
import BellFillIcon from '@/public/icons/account/bell-fill.svg';
import i18n from '@/settings/i18n';

const t = i18n.init('auth');

export default function CustomerModalHeader(props: { header: string }) {
  return (
    <div
      className="mb-4 flex items-center rounded-md bg-[#F5FFFF] p-4 text-sm text-[#497C7D] shadow-sm"
      role="alert"
    >
      <div className="mr-5 flex h-[20px] w-[20px] items-center justify-center">
        <span className="h-[20px] w-[20px]">
          <Image
            height={20}
            width={20}
            priority
            alt={t`Wishlist`}
            src={BellFillIcon}
            className="mr-4"
          />
        </span>
      </div>
      <div className="text-left">{props.header}</div>
    </div>
  );
}
